import { Constants } from './util/constants'

/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { currentUser?: API.UserInfo } | undefined,
) {
  const roleSid = initialState?.currentUser?.role_sid;

  const isAdmin = roleSid === Constants.USER.ROLE_SID.ADMIN;
  return {
    canAdmin: isAdmin,

    /**
     * 事業者管理
    **/
    // 事業者新規作成
    agencyCreate: isAdmin,
    // 事業者編集
    agencyEdit: isAdmin,
    // 事業者削除
    agencyDelete: isAdmin,
    // JP即時取得
    agencyRequestGtfsJp: isAdmin,
    // 定刻ダイヤ再構築
    agencyJsonRebuild: isAdmin,


    /**
     * 方面－系統管理
    **/
    // 方面新規作成
    routeGroupCreate: isAdmin,
    // 方面編集
    routeGroupEdit: isAdmin,
    // 方面削除
    routeGroupDelete: isAdmin,
    // 系統編集
    routeGroupRouteEdit: isAdmin,

    /**
     * 標柱グループ－標柱管理
    **/
    // 標柱グループ新規作成
    stopGroupCreate: isAdmin,
    // 標柱グループ編集
    stopGroupEdit: isAdmin,
    // 標柱グループ削除
    stopGroupDelete: isAdmin,
    // 標柱編集
    stopGroupStopEdit: isAdmin,
  };
}

